"use client";

import ActionNotification from "./actionNotification";
import InfoNotification from "./infoNotification";

export default function Notification() {
  return (
    <>
      <ActionNotification />
      <InfoNotification />
    </>
  );
}
